import React from 'react'
import ReactMarkdown from 'utils/markdown'
import SectionType from 'models/types/ts/sectionType'
import { Container, Frame } from 'layouts'
import { HeadingSmall } from 'layouts/typography'
import style from './Intro.module.scss'

interface Props {
    section: SectionType
}

const Intro = ({ section }: Props): JSX.Element => (
    <Frame cutoutBottom={false} medium className={style.intro}>
        <Container className={style.inner}>
            <div className={style.text}>
                <HeadingSmall textTransform="unset">
                    {section.headline}
                </HeadingSmall>
                <ReactMarkdown source={section.body} />
            </div>
        </Container>
    </Frame>
)

export default Intro
